export const env = {
  apiUrl: "",
  production: false,
  accounting: "https://accounting-qa.es.mpu.gov.ua/accounting/v1",
  signWidgetUrl: "https://test.id.gov.ua/sign-widget/v2022testnew/",
  realmClientId: "estock-ui-client",
  realmUrl: "https://iam-qa.es.mpu.gov.ua/auth/realms/eStock",
  activeLocale: "uk",
  eStockHomePage: "https://estock-qa.es.mpu.gov.ua/",
  documentApi: "https://document-service-qa.es.mpu.gov.ua/v1",
  logisticsServiceBackend: "https://logistics-service-qa.es.mpu.gov.ua",
};
